var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "form-group filterfield",
      attrs: {
        id: _vm.htmlId,
        "data-filterfield-type": _vm.definition.componentName,
      },
    },
    [
      _vm.showLabel
        ? _c(
            "label",
            { staticClass: "col-xs-12", attrs: { for: _vm.inputId } },
            [
              _vm._v(_vm._s(_vm.displayName) + " "),
              _c("Debug", [_vm._v("(id: " + _vm._s(_vm.id) + ")")]),
            ],
            1
          )
        : _c("Debug", [
            _c("label", { staticClass: "col-xs-12" }, [
              _vm._v("(id: " + _vm._s(_vm.id) + ")"),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12" },
        _vm._l(_vm.options, function (option, index) {
          return _c("div", { key: index, staticClass: "radio" }, [
            _c("label", { attrs: { for: _vm.inputId + "_" + index } }, [
              _c("input", {
                attrs: {
                  type: "radio",
                  name: _vm.inputId,
                  id: _vm.inputId + "_" + index,
                },
                domProps: {
                  value: option.value,
                  checked: _vm.value === option.value,
                },
                on: {
                  click: function ($event) {
                    _vm.changeValue(
                      $event,
                      option.value
                    ) /* clear if clicked again */
                  },
                  input: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "space", 32, $event.key, [
                        " ",
                        "Spacebar",
                      ])
                    )
                      return null
                    _vm.changeValue(
                      $event,
                      option.value
                    ) /* clear if clicked again */
                  },
                },
              }),
              _vm._v(" " + _vm._s(option.label || option.value)),
            ]),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "col-xs-12" }, [
            _c("small", { staticClass: "text-muted description" }, [
              _c("em", [_vm._v(_vm._s(_vm.description))]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }